import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('QR Code'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/QRCodeWidget/messages.js